import React, { useEffect, useState } from 'react'
import { IBaseDynamicFormElement } from '../Form/DynamicForm'

import { ReactComponent as ImagesIcon } from "../../assets/svg/images.svg"
import AlertElement from '../AlertElement';
import api from '../../services/api';
import CircularProgress from '@mui/material/CircularProgress';
import GenerateIcon from '../GenerateIcon';



export default function ImageUploader(props: IBaseDynamicFormElement) {

    const { id, label, fullWidth, handleOnChange, data } = props
    const [error, setError] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(false)

    const fileUploaderId: string = "file_uploader_of_" + id

   const [uploadedFile, setUploadedFile] = useState<string>(data.value)

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        if (event.dataTransfer.files.length > 0) {
          const droppedFile = event.dataTransfer.files[0];
          uploadFile(droppedFile)
        }
    };
    
    const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault(); // Necessary to allow the drop
    };
    
    const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
          const selectedFile = event.target.files[0];
          uploadFile(selectedFile)
        }
    };

    /**
     * Open image uploader
     */
    const openImageUploader = () =>  {
        if (document.getElementById(fileUploaderId) !== null) {
            document.getElementById(fileUploaderId)!.click()
        }
    }

    /**
     * Clear upload
     */
    const clearUpload = () => {
        setUploadedFile("")
        handleOnChange(id, "")
    }

    /**
     * Upload file 
     */
    const uploadFile = async(file: File) => {

        setLoading(true)

        const formData = new FormData()
        formData.append('image', file)

        await api.post("/uploader/image", formData, { headers: {
            'Content-Type': 'multipart/form-data',
          }})
            .then(response => {

                
                const { data } = response

                setError("")
                setLoading(false)

                setUploadedFile(data.url)
                handleOnChange(id, data.url)

            })
            .catch(error => {
                const { status, statusText, data } = error.response
                const message = data.message ? data.message : "Unknown Error"
                setLoading(false)
                setError(message)
            })
    }

    useEffect(() => {
        if (data.value){
            setUploadedFile(data.value)
        }else{
            setUploadedFile("")
        }
    }, [data.value])

    return(
        <div className="image-uploader-container">
            <div className="content-of-image-uploader-container">

            <input

                type="file"
                onChange={handleFileSelect}
                style={{ display: 'none' }}
                id={fileUploaderId}
            />

                {label && <h3 className="label-of-image-uploader-container">{label}</h3>}

                <div className="image-uploader-drop-zone-box" onDrop={handleDrop} onDragOver={handleDragOver}>
                    <div className="content-of-image-uploader-drop-zone-box">

                        <div className={loading ? "preloader-of-image-uploader-drop-zone-box active" : "preloader-of-image-uploader-drop-zone-box"}>
                            <div className="content-of-preloader-of-image-uploader-drop-zone-box">
                                <CircularProgress />
                            </div>
                        </div>

                        {uploadedFile && (
                            <div className="uploaded-image-of-image-uploader-drop-zone-box">
                                <div className="content-of-uploaded-image-of-image-uploader-drop-zone-box">
                                    <div className="mask-box-of-uploaded-image-of-image-uploader-drop-zone-box" onClick={() => clearUpload()}>
                                        <div className="content-of-mask-box-of-uploaded-image-of-image-uploader-drop-zone-box">
                                            <GenerateIcon icon="delete" />
                                        </div>
                                    </div>
                                    <img src={uploadedFile} />
                                </div>
                            </div>
                        )}
                        
                        {!uploadedFile && (
                            <div className="upload-section-of-image-uploader-drop-zone-box">
                                <div className="icon-of-image-uploader-drop-zone-box">
                                    <div className="content-of-icon-of-image-uploader-drop-zone-box">
                                        <ImagesIcon />
                                    </div>
                                </div>

                                <div className="text-of-image-uploader-drop-zone-box">
                                    <div className="content-of-text-of-image-uploader-drop-zone-box">
                                        <h3>Drop or select file</h3>
                                        <p onClick={() => openImageUploader()}>Drop files here or click to <span className="highlighted-text">browse</span> through your machine.</p>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>

                {error && <div style={{ paddingTop: 10 }}><AlertElement type="error" message={error} /></div>}

            </div>
        </div>
    )
}